import { Injectable } from "@angular/core";
import { CommonService } from "../common.service";

export interface Menu {
  state: string;
  name: string;
  type: string;
  iconUrl: string;
  iconUrlActive: string;
}

const MENUITEMS = [
  {
    state: "dashboard",
    name: "Dashboard",
    type: "link",
    iconUrl: "assets/images/ic_dashboard.svg",
    iconUrlActive: "assets/images/ic_dashboard_active.svg",
    access: "dashboard",
  },
  // {
  //   state: "analytic",
  //   name: "Analytics",
  //   type: "link",
  //   icon: "insert_chart_outlined",
  //   iconColor: "#FF5959",
  //   show: true,
  // },
  // { state: 'map', type: 'link', name: 'Map View',iconUrl: 'assets/images/ic_map.svg',iconUrlActive: 'assets/images/ic_map_active.svg', access: 'users' },
  {
    state: "user-management",
    type: "link",
    name: "Users",
    iconUrl: "assets/images/ic_user.svg",
    iconUrlActive: "assets/images/ic_user_active.svg",
    access: "users",
  },
  // {
  //   state: "roles",
  //   type: "link",
  //   name: "Roles",
  //   iconUrl: "assets/images/ic_role.svg",
  //   iconUrlActive: "assets/images/ic_role_active.svg",
  //   access: "roles",
  // },

  {
    state: "provider-management",
    type: "link",
    name: "Professionals",
    iconUrl: "assets/images/ic_driver.svg",
    iconUrlActive: "assets/images/ic_driver_active.svg",
    access: "drivers",
  },
  {
    state: "platform-fee-commission",
    type: "link",
    name: "Platform Commission",
    iconUrl: "assets/images/ic_invoice.svg",
    iconUrlActive: "assets/images/ic_invoice_active.svg",
    access: "drivers",
  },
  {
    state: "service-area-management",
    type: "link",
    name: "Manage Services",
    iconUrl: "assets/images/service.svg",
    iconUrlActive: "assets/images/service copy.svg",
    access: "serviceArea",
  },
  {
    state: "promo",
    type: "link",
    name: "Manage Coupons",
    iconUrl: "assets/images/ic_promo.svg",
    iconUrlActive: "assets/images/ic_promo_active.svg",
    access: "users",
  },
  // { state: 'reports-management', type: 'link', name: 'Reports', icon: 'subtitles',iconColor: '#FF5959', show: true,access: 'reports' },
  // { state: 'vehicle', type: 'link', name: 'Vehicles', icon: 'directions_car', iconColor: '#CF2D2D', access: 'vehicles' },
  // { state: 'driver-management', type: 'link', name: 'Drivers', icon: 'directions_car', svgIcon: 'driver', iconColor: '#4A3BD8', access: 'drivers' },
  {
    state: "bookings",
    type: "link",
    name: "Manage Bookings",
    iconUrl: "assets/images/service.svg",
    iconUrlActive: "assets/images/service copy.svg",
  },

  {
    state: "booking-history",
    type: "link",
    name: "Booking History",
    iconUrl: "assets/images/history_black.svg",
    iconUrlActive: "assets/images/history_white.svg",
  },
  {
    state: "provider-payout",
    type: "link",
    name: "Manage Payout",
    iconUrl: "assets/images/ic_list.svg",
    iconUrlActive: "assets/images/ic_list_active.svg",
  },
];

const MENUITEMSOTHER = [ 
  {
    state: "affiliate",
    type: "link",
    name: "Manage Affiliates",
    iconUrl: "assets/images/affiliate_active.svg",
    iconUrlActive: "assets/images/affiliate_active.svg",
  },
]
@Injectable()
export class MenuItems {
  currentRole = 'all'

  constructor(private commonService: CommonService) {}
  getMenuitem(value): Menu[] {
    console.log('2')
    switch (value) {
      case 'affiliate':
        return MENUITEMSOTHER;
      case 'all':
        return MENUITEMS;
      default:
        return MENUITEMS;
    }
  }
}
